import { z } from 'zod';
const boolish = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((v) => v === true || v === 'true' || v === '1');
export const searchQuerySchema = z.object({
    q: z.string().min(1).max(1000),
    limit: z.coerce.number().int().min(1).max(200).default(20),
    offset: z.coerce.number().int().min(0).default(0),
    /** Treat the last term as a prefix (as-you-type). */
    prefix: boolish.default(false),
    type: z.string().optional(),
    tag: z.string().optional(),
    folder: z.string().optional(),
    /** hybrid (default) fuses keyword + vector + graph; keyword is FTS only. */
    mode: z.enum(['hybrid', 'keyword']).default('hybrid'),
});
//# sourceMappingURL=search.js.map